import { z } from 'zod';

const prescriptionItemSchema = z.object({
  nameOrMedicineId: z.string().min(1, 'Medicine name is required'),
  dose: z.string().min(1, 'Dose is required'),
  frequency: z.string().min(1, 'Frequency is required'),
  duration: z.string().min(1, 'Duration is required'),
  route: z.string().optional(),
  instructions: z.string().optional(),
});

export const prescriptionSchema = z.object({
  patientId: z.string().min(1, 'Patient is required'),
  items: z.array(prescriptionItemSchema).min(1, 'At least one medicine is required'),
  advice: z.string().optional(),
  followUpDate: z.string().optional(),
  signedBy: z.string().optional(),
});

export type PrescriptionFormData = z.infer<typeof prescriptionSchema>;
